import request from '@/config/axios'
import type { CashbackGrantVO } from '@/api/mall/trade/cashback/plan'

export type { CashbackGrantVO }

export const getCashbackGrantPage = async (params: any) => {
  return await request.get({ url: '/trade/cashback/grant/page', params })
}
